/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useDispatch } from 'react-redux';
import { showPopup } from '@/store/modal';
// eslint-disable-next-line no-unused-vars
import { isWeb, isMobileWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import BackButton from '@components/navbar/BackButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import MoreButton from '@components/navbar/MoreButton';
import LoyaltyScreen from '@/screens/customer/loyalty/LoyaltyScreen';
import LoyaltyDetailScreen from '@/screens/customer/loyalty/LoyaltyDetailScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const LoyaltyNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  const dispatch = useDispatch();
  return (
    <Stack.Navigator
      initialRouteName="LoyaltyScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="LoyaltyScreen"
        component={LoyaltyScreen}
        options={(props) => {
          const showFilter = () =>
            dispatch(showPopup({ name: 'showFilter', value: true }));
          const showExport = () =>
            dispatch(showPopup({ name: 'exportLoyalty', value: true }));
          return {
            title: setTitleHeader('Loyalty Point'),
            hideScroll: true,
            headerLeft: () => <HamburgerButton {...props} />,
            headerRight: () =>
              isWeb ? (
                <NotificationSettingButton {...props} />
              ) : (
                <MoreButton
                  menu={[
                    { type: 'function', name: 'Filter', callback: showFilter },
                    {
                      type: 'function',
                      name: 'Export Loyalty Point',
                      callback: showExport,
                    },
                  ]}
                  {...props}
                />
              ),
          };
        }}
      />
      <Stack.Screen
        name="LoyaltyDetailScreen"
        component={LoyaltyDetailScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Detail Customer';
          if (route.params && route.params.name && !(isWeb && !isMobileWeb)) {
            title = route.params.name;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => <BackButton {...props} />,
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default LoyaltyNavigator;
